package com.neurobs.js.view

object MessageBoxResult extends Enumeration {
	val Ok, Yes, No, Cancel = Value
}

case class MessageBox(view: Container, buttons: Seq[(Button, MessageBoxResult.Value)])

object MessageBox {

	def showModal(box: MessageBox, modal: ModalView)(onComplete: (MessageBoxResult.Value) => Unit): Unit = {
		box.buttons.foreach( b =>
			b._1.setHandler( () => {
					modal.dismiss(box.view)
					onComplete(b._2)
				}
			)
		)
		modal.show(box.view)
	}
}